module.exports = "https://images.shiksha.ws/saassets/media/ContactUsPhnIcn2.b8a4f9cf.svg";